module.exports = __webpack_public_path__ + "static/preview-48d726d90a111f0ef00441db07ae609c.png";